import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  IconButton,
  Card,
  Divider,
  List,
  ListItem,
  Theme,
} from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import SettingsIcon from '@mui/icons-material/Settings'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import TableViewIcon from '@mui/icons-material/TableView'
import LoyaltyIcon from '@mui/icons-material/Loyalty'
import EventIcon from '@mui/icons-material/Event'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AssessmentIcon from '@mui/icons-material/Assessment'
import DashboardIcon from '@mui/icons-material/Dashboard'

import { getCrudeAppName } from '../../../store/settings/settings.selectors'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      position: 'absolute',
      top: 30,
      bottom: 'auto',
      left: 'auto',
      backgroundColor: theme.palette.background.paper,
      minWidth: 170,
      zIndex: 1001,
    },
    button: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-start',
      fontSize: '14px!important',
      fontWeight: theme.typography.fontWeightRegular,
      padding: '7px',
      color: theme.palette.text.primary,
      borderRadius: '0px',
    },
  }),
)

export interface SettingsMenuProps<> {
  user: any
  showSettingsMenu: boolean
  setShowSettingsMenu: (show: boolean) => void
  doLogout: () => void
}

const SettingsMenu = (props: SettingsMenuProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()

  const appName: string = useSelector(getCrudeAppName)

  const setShowSettingsMenu = props.setShowSettingsMenu
  const doLogout = props.doLogout

  const onSelectDashboard = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push('/')
    },
    [setShowSettingsMenu],
  )

  const onSelectCrude = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push(`/${appName}/Contact/`)
    },
    [setShowSettingsMenu],
  )

  const onSelectInvoice = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push('/Invoice/')
    },
    [setShowSettingsMenu],
  )

  const onSelectEventInvoice = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push('/event-invoice')
    },
    [setShowSettingsMenu],
  )

  const onSelectAttendance = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push('/attendance')
    },
    [setShowSettingsMenu],
  )

  const onSelectReports = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push('/reports')
    },
    [setShowSettingsMenu],
  )

  const onSelectSettings = useCallback(
    () => {
      setShowSettingsMenu(false)
      history.push('/settings')
    },
    [setShowSettingsMenu],
  )

  const onLogout = useCallback(
    () => {
      setShowSettingsMenu(false)
      doLogout()
    },
    [setShowSettingsMenu, doLogout],
  )
  if (!props.showSettingsMenu) {
    return (<div />)
  }
  return (
    <>
      {
        !props.showSettingsMenu
          ? <div />
          : (
            <Card
              className={classes.dialog}
            >
              <List>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectDashboard}>
                    <DashboardIcon style={{ marginRight: 10 }} />{t('common:dashboard')}
                  </IconButton>
                </ListItem>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectCrude}>
                    <TableViewIcon style={{ marginRight: 10 }} />Verwaltung
                  </IconButton>
                </ListItem>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectInvoice}>
                    <LoyaltyIcon style={{ marginRight: 10 }} />Mitgliedsrechnungen
                  </IconButton>
                </ListItem>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectEventInvoice}>
                    <EventIcon style={{ marginRight: 10 }} />Veranstaltungsrechnungen
                  </IconButton>
                </ListItem>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectAttendance}>
                    <CheckCircleIcon style={{ marginRight: 10 }} />Eventmanagement
                  </IconButton>
                </ListItem>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectReports}>
                    <AssessmentIcon style={{ marginRight: 10 }} />Reports
                  </IconButton>
                </ListItem>
                <ListItem>
                  <IconButton className={classes.button} onClick={onSelectSettings}>
                    <SettingsIcon style={{ marginRight: 10 }} /> {t('common:settings')}
                  </IconButton>
                </ListItem>
                <li>
                  <Divider />
                </li>
                <ListItem>
                  <IconButton className={classes.button} onClick={onLogout}>
                    <PowerSettingsNewIcon style={{ marginRight: 10 }} /> {t('common:logout')}
                  </IconButton>
                </ListItem>
              </List>
            </Card>
          )
      }
    </>
  )
}

export default SettingsMenu
